import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Admin from './components/Admin';
import NotFound from './components/NotFound';
import OrdersServerBoost from './components/OrdersServerBoost';
import OrdersAccounts from './components/OrdersAccounts';
import Login from './components/Login';
import RequireAuth from './components/RequireAuth';
import ButtonPersonalPage from './components/zacks';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Default false for unauthenticated users

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setIsAuthenticated(!!token); // Convert token to boolean: true if present, false if not
  }, []);

  return (
    <Router>
      <Routes>
        {/* Login route */}
        <Route path={process.env.REACT_APP_LOGIN} element={<Login setIsAuthenticated={setIsAuthenticated} />} />

        {/* Protected routes */}
        <Route
          path={process.env.REACT_APP_ADMIN}
          element={
            <RequireAuth isAuthenticated={isAuthenticated}>
              <Admin />
            </RequireAuth>
          }
        />
        <Route
          path={process.env.REACT_APP_SERVER_BOOSTS}
          element={
            <RequireAuth isAuthenticated={isAuthenticated}>
              <OrdersServerBoost />
            </RequireAuth>
          }
        />
        <Route
          path={process.env.REACT_APP_ACCOUNTS}
          element={
            <RequireAuth isAuthenticated={isAuthenticated}>
              <OrdersAccounts />
            </RequireAuth>
          }
        />
        <Route
          path={process.env.REACT_APP_PRIVATEE}
          element={
            <RequireAuth isAuthenticated={isAuthenticated}>
              <ButtonPersonalPage />
            </RequireAuth>
          }
        />
		
        <Route path={process.env.REACT_APP_PRIVATE} element={<ButtonPersonalPage />} />
		<Route path={process.env.REACT_APP_info} element={<ButtonPersonalPage />} />
		
        {/* Fallback route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
